import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withRouter } from 'react-router-dom';

import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { EditorState } from 'draft-js';
import 'draft-js/dist/Draft.css';

import { stateFromHTML } from 'draft-js-import-html';

import { connect } from 'react-redux';

import {
  getFooterPage,
} from '../../../actions/contentManagement';

class PartnerFAQPage extends Component {
  static propTypes = {
    fetchFooterPage: PropTypes.func.isRequired,
  };

  static defaultProps = {
  };

  constructor(props) {
    super(props);
    this.state = {
      content: null,
      editorState: EditorState.createEmpty(),
    };
  }

  componentDidMount() {
    const { fetchFooterPage } = this.props;
    console.log('fetchFooterPage test');

    fetchFooterPage('partnerFAQ').then((res) => {
      console.log('fetchFooterPage', { res });
      if (res && res.text) {
        let contentState = stateFromHTML(res.text);

        if (contentState) {
          this.setState({ editorState: EditorState.createWithContent(contentState) });
        }

        this.setState({ content: res.text });
      }
    });
  }


  render() {
    const {
      content,
      editorState,
    } = this.state;

    return (
      <div>
        <Editor
          className="content-management-text-area"
          readOnly
          toolbarHidden
          editorState={editorState}
          toolbarClassName="toolbarClassName"
          wrapperClassName="wrapperClassName"
          editorClassName="editorClassName"
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
});

const mapDispatchToProps = {
  fetchFooterPage: getFooterPage,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PartnerFAQPage));
